import { getRosterUrl, getUsersUrl } from "../config/Config";
import { getRequest, patchRequest, putRequest } from "./ServiceHelper";

export class UserService {
  static getUsers = (startRange, endRange) => {
    let param = {};
    if (startRange && endRange) {
      param.range_start = startRange;
      param.range_end = endRange;
    }
    return getRequest(getUsersUrl(), param);
  };

  static #patchUser = (param) => {
    return patchRequest(getUsersUrl() + "/", param);
  };

  static setUserRole(canvasId, roleId) {
    return this.#patchUser({ canvas_id: canvasId, role_id: roleId });
  }

  static getUserById = (userId) => {
    return getRequest(getUsersUrl() + "/" + userId);
  };

  static setAcSubjects(canvasId, acSubjects) {
    return this.#patchUser({ canvas_id: canvasId, ac_subjects: acSubjects });
  }

  static getRosterByContext(contextId) {
    return getRequest(getRosterUrl(contextId));
  }

  static addUserToOffering(canvasId, contextId) {
    let params = {};
    params.studentCanvasId = canvasId;
    params.contextId = contextId;
    return putRequest(getUsersUrl() + "/add/offering", params);
  }
  static removeUserFromOffering(studentId, contextId) {
    let params = {};
    params.contextId = contextId;
    return putRequest(getUsersUrl() + "/remove/" + studentId, params);
  }
}
